import ActionId from "@/action/ActionId"
import BasePreAuthAction from "@/action/actions/BasePreAuthAction"
import { applyService } from "@/service"

class SubmitPrescreenAction extends BasePreAuthAction {

    #application = null

    constructor(providerKey, application) {
        super(ActionId.SUBMIT_PRESCREEN, providerKey)
        this.#application = application
    }

    async _submit() {
        return applyService.prescreen(this.providerKey, {
            application: this.#application,
        })
    }
}


export default SubmitPrescreenAction
